/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Sector } from 'recharts';
import { formatNumber } from '../../../../helpers/number-formatters';

const constants = {
  TOOLTIP_TITLE_FONTSIZE: 12,
  TOOLTIP_DESCRIPTION_FONTSIZE: 10,
  TEXT_OFFSET: 12,
  START_OFFSET: 10,
  MIDDLE_OFFSET: 30,
  END_OFFSET: 15,
  OUTER_EXTRA_RADIUS: 15,
  INNER_EXTRA_RADIUS: 10,
};

const mobileConstants = {
  TOOLTIP_TITLE_FONTSIZE: 10,
  TOOLTIP_DESCRIPTION_FONTSIZE: 8,
  TEXT_OFFSET: 8,
  START_OFFSET: 5,
  MIDDLE_OFFSET: 20,
  END_OFFSET: 8,
  OUTER_EXTRA_RADIUS: 10,
  INNER_EXTRA_RADIUS: 5,
};

export const ActiveShape = (props: any): JSX.Element => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    value,
    data,
    activeIndex,
    small,
  } = props;
  const values = small ? mobileConstants : constants;

  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + values.START_OFFSET) * cos;
  const sy = cy + (outerRadius + values.START_OFFSET) * sin;
  const mx = cx + (outerRadius + values.MIDDLE_OFFSET) * cos;
  const my = cy + (outerRadius + values.MIDDLE_OFFSET) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * values.END_OFFSET;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  const tipWidth = 7;
  const sinTip1 = Math.sin(-RADIAN * (midAngle - tipWidth));
  const cosTip1 = Math.cos(-RADIAN * (midAngle - tipWidth));
  const xTip1 = cx + (outerRadius + values.OUTER_EXTRA_RADIUS) * cosTip1;
  const yTip1 = cy + (outerRadius + values.OUTER_EXTRA_RADIUS) * sinTip1;

  const sinTip2 = Math.sin(-RADIAN * (midAngle + tipWidth));
  const cosTip2 = Math.cos(-RADIAN * (midAngle + tipWidth));
  const xTip2 = cx + (outerRadius + values.OUTER_EXTRA_RADIUS) * cosTip2;
  const yTip2 = cy + (outerRadius + values.OUTER_EXTRA_RADIUS) * sinTip2;

  const xTip3 = cx + (outerRadius + values.OUTER_EXTRA_RADIUS + 7) * cos;
  const yTip3 = cy + (outerRadius + values.OUTER_EXTRA_RADIUS + 7) * sin;

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {/*payload.name*/ ''}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + values.OUTER_EXTRA_RADIUS}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
        className="active-section-shadow"
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <path
        d={`M${xTip1},${yTip1}L${xTip2},${yTip2}L${xTip3},${yTip3}`}
        stroke={fill}
        fill={fill}
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * values.TEXT_OFFSET}
        y={ey}
        textAnchor={textAnchor}
        fontSize={values.TOOLTIP_TITLE_FONTSIZE}
        fontWeight="bold"
        fill="var(--primary-text-color)"
      >
        {payload.name}
      </text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * values.TEXT_OFFSET}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fontSize={values.TOOLTIP_DESCRIPTION_FONTSIZE}
        fontWeight="bold"
        fill="var(--primary-text-color)"
      >
        {`${data[activeIndex].percent.toFixed(2)}%`}
      </text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * values.TEXT_OFFSET}
        y={ey}
        dy={36}
        textAnchor={textAnchor}
        fontSize={values.TOOLTIP_DESCRIPTION_FONTSIZE}
        fontWeight="bold"
        fill="var(--gray-text-color)"
      >
        {formatNumber(value, 'HUF')}
      </text>
    </g>
  );
};

export const InnerActiveShape = (props: any): JSX.Element => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, small } = props;
  const values = small ? mobileConstants : constants;

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius - values.INNER_EXTRA_RADIUS}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

const RADIAN = Math.PI / 180;
export const CustomizedLabel = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  index,
  activeIndex,
  data,
  fill,
  small,
}: any): JSX.Element | null => {
  if (index === activeIndex) {
    return null;
  }
  const values = small ? mobileConstants : constants;

  const radius = outerRadius + values.OUTER_EXTRA_RADIUS;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);

  const tipWidth = 7;
  const sinTip1 = Math.sin(-RADIAN * (midAngle - tipWidth));
  const cosTip1 = Math.cos(-RADIAN * (midAngle - tipWidth));
  const xTip1 = cx + outerRadius * cosTip1;
  const yTip1 = cy + outerRadius * sinTip1;

  const sinTip2 = Math.sin(-RADIAN * (midAngle + tipWidth));
  const cosTip2 = Math.cos(-RADIAN * (midAngle + tipWidth));
  const xTip2 = cx + outerRadius * cosTip2;
  const yTip2 = cy + outerRadius * sinTip2;

  const xTip3 = cx + (outerRadius + 7) * cos;
  const yTip3 = cy + (outerRadius + 7) * sin;

  const percentage = data[index].percent;

  return (
    <g>
      <path
        d={`M${xTip1},${yTip1}L${xTip2},${yTip2}L${xTip3},${yTip3}`}
        stroke={fill}
        fill={fill}
      />
      <text
        x={x}
        y={y}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        fontSize={10}
        fontWeight="bold"
        fill="var(--primary-text-color)"
      >
        {`${percentage.toFixed(2)}%`}
      </text>
    </g>
  );
};
